module.exports = __webpack_public_path__ + "static/media/dots.f31257f1.svg";